<template>
    <div class="data-filter">
        <template v-if="prime">
            <button type="button" class="btn btn-primary" v-on:click="$emit('prime')"><i :class="prime.icon || `fa fa-plus`"></i> {{ $t(prime.title) }}</button>
        </template>
        <div class="data-filter-left">
            <field
                    v-if="search"
                    name="search"
                    type="text"
                    ref="txtSearch"
                    v-model="filters.search"
                    field-class="filter-field"
                    v-on:keyenter="$emit('change', 'search')"
                    :placeholder="$t(search.placeholder || 'Action.search')"
            >
                <span class="append-icon">
                  <a v-if="filters.search != ''" v-on:click="resetSearch">
                    <i class="fas fa-times-circle"></i>
                  </a>
                  <i v-else class="fas fa-search"></i>
                </span>
            </field>
        </div>
        <div class="data-filter-spacer"></div>
        <div class="data-filter-right" v-for="ctrl in right">
            <field
                    :name="ctrl.id"
                    type="select"
                    v-model="filters[ctrl.id]"
                    :options="ctrl.options"
                    field-class="filter-field"
                    v-on:input="$emit('change', ctrl.id)"
                    :placeholder="$t(ctrl.placeholder)"
            ></field>
        </div>
    </div>
</template>

<script>

    export default {
      name: 'DataFilter',
      props: {
        prime: Object,
        search: Object,
        right: Array,
        filters: Object,
      },

      watch: {
        right() {
          console.log('The right has changed!');
          this.$forceUpdate()
        }
      },

      methods: {
        resetSearch() {
          this.filters.search = '';
          this.$forceUpdate();
          this.$emit('change');
        }
      }
    }
</script>

<style>
    .data-filter {
        display: flex;
        flex: 1;
        flex-direction: row;
    }

    .data-filter .btn-primary {
        height: 36px !important;
    }

    .data-filter > * {
        flex: 0;
        margin-right: 15px;
    }

    .data-filter > *:last-child {
        margin-right: 0;
    }

    .data-filter .data-filter-spacer {
        flex: 1;
    }

    @media (max-width: 640px) {
        .data-filter {
            display: block;
            margin-right: 0;
        }

        .data-filter > * {
            display: block;
            width: 100%;
            margin-bottom: 15px;
        }

        .data-filter .data-filter-spacer {
            display: none !important;
        }

        .data-filter .filter-field {
            width: 100%;
        }
    }

</style>
